import React from 'react';

function NotFound() {
    return <div>
        <title>404</title>
        <h3>404</h3>
        <h2 className='error'>Stránka nenalezena lol</h2>
    </div>;
}

export default NotFound;
